import { render } from "./inicio.vue?vue&type=template&id=18f77da6"
import script from "./inicio.vue?vue&type=script&lang=js"
export * from "./inicio.vue?vue&type=script&lang=js"

import "./inicio.vue?vue&type=style&index=0&id=18f77da6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__